import {
  Component,
  ViewChild,
  ComponentRef,
  EmbeddedViewRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  CdkPortalOutlet,
  ComponentPortal,
  TemplatePortal,
  BasePortalOutlet
} from '@angular/cdk/portal';

@Component({
  selector: 'sc-popover',
  template: `
    <ng-container cdkPortalOutlet></ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScPopoverComponent extends BasePortalOutlet {
  @ViewChild(CdkPortalOutlet, { static: true }) portalOutlet: CdkPortalOutlet;

  attachComponentPortal<T>(
    componentPortal: ComponentPortal<any>
  ): ComponentRef<T> {
    return this.portalOutlet.attachComponentPortal(componentPortal);
  }

  attachTemplatePortal<C>(portal: TemplatePortal<C>): EmbeddedViewRef<C> {
    return this.portalOutlet.attachTemplatePortal(portal);
  }
}
